import { programs } from '@metaplex/js';
import * as anchor from "@coral-xyz/anchor";
import { useAnchorWallet } from "solana-wallets-vue";
import { computed } from "vue";
import { AnchorProvider, web3 , Provider} from "@project-serum/anchor";
import { Program } from "@coral-xyz/anchor";
import {  Connection,clusterApiUrl, PublicKey,ComputeBudgetProgram} from "@solana/web3.js";
import { useWallet } from 'solana-wallets-vue';
export { TokenStandard } from '@metaplex-foundation/mpl-token-metadata';
import * as pda from './pda'
import {LUTUA,getLUTColl} from './getLUT'
const SOLANA_NETWORK = 'https://alien-dimensional-county.solana-mainnet.quiknode.pro/8dd797f9530c73d6a499a7b28a17e1d28bfc4f0e/'; 
export const connection = new Connection(SOLANA_NETWORK);

export async function checkifinitialized(){
  const wallet = useAnchorWallet();
  const idl = require('./burndev.json');
  const preflightCommitment = "processed";
  const commitment = "confirmed"; 
  const provider = computed(
    () =>
      new anchor.AnchorProvider(connection, wallet.value!, {
        preflightCommitment,
        commitment,
      })
  );
  const mprogram = new anchor.Program(idl,provider.value)
  const MINT_SEED = "mint";

  const [Mint] = PublicKey.findProgramAddressSync(
    [Buffer.from(MINT_SEED)],
    mprogram.programId,
  );
  const tokenAccount =  anchor.utils.token.associatedAddress({
    mint: Mint,
    owner: provider.value.publicKey,
  });
  const response = await connection.getAccountInfo(tokenAccount);
  if (response == null || response.data == null){
    return false
  }
  else{
    return true
  }
}
async function fetchColl(searching:any) {
  try {
    
    const response2 = await fetch('/data/groupedcoll.json');
    if (!response2.ok) {
      throw new Error('Failed to fetch groupedcoll.json');
    }
    const UA = await response2.json();
    let lookup
   // console.log("started searching:",searching, typeof searching)
    const response = await UA.forEach(async function(element:any,index:any){
      element.forEach(async function(element2:any){
        if(element2.collection == searching ){
         // console.log("found it")
            lookup = await getLUTColl(element2.numMints)
        }
      })
    })
    return lookup
  } catch (err) {
    console.error('NFT not accepted, doesnt meet all criterias', err);
  }
}
async function getIDL(){
  const idl = require('./burndev.json');
  const wallet = useAnchorWallet();
  const preflightCommitment = "processed";
  const commitment = "confirmed";  
  const provider = computed(
    () =>
      new anchor.AnchorProvider(connection, wallet.value!, {
        preflightCommitment,
        commitment,
      })
  );
  const mprogram = new anchor.Program(idl,provider.value)
  return {mprogram,provider}
}
async function fetchLUTUA(searching:any) {
  try {
    
    const response2 = await fetch('/data/groupedUA.json');
    if (!response2.ok) {
      throw new Error('Failed to fetch groupedUA.json');
    }
    //console.log(searching,"searching for this one")
    const UA = await response2.json();
    let lookup
    const response = await UA.forEach(async function(element:any,index:any){
      element.forEach(async function(element2:any){
        if(element2.ua == searching ){
          //console.log("FOUNDIT")

            lookup = await LUTUA(element2.numMints)
            //console.log("returning tHIS ONE",lookup)

        }
      })
    })
   // console.log("returning this one frfr",lookup)
    return lookup
  } catch (err) {
    console.error('NFT not accepted, doesnt meet all criterias', err);
  }
}

export async function stickAccounts(tx:any,accounts:any){

}
export async function burnNFT(mint:any) {
  
//console.log(mint)
  if (mint.metadata.data.collection == undefined && mint.metadata.data.updateauthority) {
    return new Error("NFT Not Accepted, doesn't have a collection in its metadata or UA");
  }
  
  if(mint.metadata.data.collection != undefined && mint.metadata.data.collection.verified != 1 ){
    return Error("NFT Not Accepted, NFT is not verified by collection")
  }
  try{
  const {mprogram,provider} = await getIDL()
  const METADATA_SEED = "metadata";
  const TOKEN_METADATA_PROGRAM_ID = new PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s");
  const MINT_SEED = "mint";
  const mintpubkey = new PublicKey(mint.metadata.data.mint.toString());
  const [Mint] = PublicKey.findProgramAddressSync(
    [Buffer.from(MINT_SEED)],
    mprogram.programId,
  );
  const dummy = new PublicKey("1nc1nerator11111111111111111111111111111111")
  const [metadata,bumpmeta] = pda.findMetadataPda(mintpubkey)
  const tokenAccount =  anchor.utils.token.associatedAddress({
    mint: Mint,
    owner: provider.value.publicKey,
  });



  const NFTATA =  anchor.utils.token.associatedAddress({
    mint: mintpubkey,
    owner: provider.value.publicKey,
  });

  const [edition_pda,edibump] = pda.findMasterEditionPda(mintpubkey)
  const [record,recbump] = pda.findTokenRecordPda(mintpubkey,NFTATA)
  const tokenAccountElmo = anchor.utils.token.associatedAddress({
    mint: Mint,
    owner: new PublicKey("eLmoWNfGJuXfKBVMRDrwQKRHJKUBCV8ty6U32baTjAv"),
  })

  let identifier
  let lookuptablee
  let arg
  if(mint.metadata.data.collection == undefined){

    identifier = new PublicKey(mint.metadata.data.updateAuthority)

    lookuptablee = await fetchLUTUA(mint.metadata.data.updateAuthority)
    arg = false

  }
  else{

    const [identifier2,idenbump] = await pda.findMetadataPda(new PublicKey(mint.metadata.data.collection.key))
    identifier = identifier2

    lookuptablee = await fetchColl(mint.metadata.data.collection.key)
    arg = true
  }

  const ata = {pubkey: NFTATA, isSigner: false, isWritable: true};
  const mintpub = {pubkey: mintpubkey, isSigner: false, isWritable: true};
  const metadata2 = {pubkey:metadata, isSigner: false, isWritable: true};
  const edition =  {pubkey: edition_pda, isSigner: false, isWritable: true};
  const dummy2 = {pubkey:dummy, isSigner: false, isWritable: false};
  const record2 = {pubkey:record, isSigner: false, isWritable: true};
  const collection_metadata = {pubkey: identifier, isSigner: false, isWritable: true};

  const remaining2 = [mintpub, metadata2, edition, ata, collection_metadata, dummy2, dummy2, dummy2, dummy2, record2];
  const tx = await mprogram.methods.burnprint(
    arg 
  )
  if(lookuptablee == undefined){
    throw Error("This NFT is not accepted, Sorry")
  }
  const registryAccount = new PublicKey("vzc7MY71QEmMkHqy1NKrux5JExFc9s6vfz5GT65CrMF")
  const sysvarInstr = new PublicKey("Sysvar1nstructions1111111111111111111111111")
  const LUTFINAL = new PublicKey(lookuptablee)
  const providerpubkey = new PublicKey(provider.value.publicKey)
  const collection_metadata_tx = new PublicKey(collection_metadata.pubkey)
  const txBuildAccounts = {
    registryAccount: registryAccount ,
    tokenAccount: tokenAccount , 
    payer: providerpubkey , 
    lookupTable: LUTFINAL,
    sysvarInstructions: sysvarInstr,
    collectionMetadata: identifier ,  
    tokenAccountElmo: tokenAccountElmo,
  }

  const txBuild = tx.accountsPartial(txBuildAccounts);  
    

  const remaining = txBuild.remainingAccounts(
    remaining2
  )

  const txFinal = await remaining.rpc({
    skipPreflight: true
  })

 // console.log("Your transaction signature", txFinal);
  return txFinal
  }catch(error){
    throw Error("Error executing burn transaction:"+ error)
  }

}
export async function initializeUser() {
  
  const idl = require('./burndev.json');
  const wallet = useAnchorWallet();
  const preflightCommitment = "processed";
  const commitment = "confirmed";  
  const provider = computed(
    () =>
      new anchor.AnchorProvider(connection, wallet.value!, {
        preflightCommitment,
        commitment,
      })
  );

  const mprogram = new anchor.Program(idl,provider.value)
  const MINT_SEED = "mint";

  const [Mint] = PublicKey.findProgramAddressSync(
    [Buffer.from(MINT_SEED)],
    mprogram.programId,
  );
    const tokenAccount =  anchor.utils.token.associatedAddress({
      mint: Mint,
      owner: provider.value.publicKey,
    });
    // Assuming necessary imports and initial setup
    const method = mprogram.methods.initializeUser();
    const accounts = method.accountsPartial({ 
      tokenAccount, 
      payer: wallet.value!.publicKey,  
    }) as any;
    try {
      const tx = await accounts.rpc();
      //console.log("Transaction response:", tx);
      const result = await connection.getSignatureStatus(tx);
      if(result.value!.confirmationStatus == "confirmed"){
        return true
      }
      else{
        return false
      }
      //console.log(result)
    } catch (error) {
      console.error("Error executing transaction:", error);
      
      throw Error("Error executing transaction:"+ error)
      return false

    }  
}

export async function getNftsForOwner(ownerAddress:string) {
  //const wallet = useAnchorWallet();
  const wallet = useWallet()
  const ownerPublicKey = wallet.publicKey!;
  const tokenAccounts = await connection.getParsedTokenAccountsByOwner(ownerPublicKey.value!, {
    programId: new PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA')
  });
  const nftAccounts = tokenAccounts.value.filter(account => {
    const amount = account.account.data.parsed.info.tokenAmount.uiAmount;
    return amount === 1; // NFTs have an amount of 1
  });

  return nftAccounts;
}
interface FinalData {
  fetched?: any;
  metadata?: any;
}

export async function fetchNftMetadata(mintAddress:string) {
    try {
        const { metadata: { Metadata } } = programs;
        const regex = /^https:\/\/testlaunchmynft\.myp/;

        // Create PublicKey object from mint address
        const mintPublicKey = new PublicKey(mintAddress);
        // Derive the metadata account address
        const metadataAccount = await Metadata.getPDA(mintPublicKey);
        // Fetch the metadata
        //console.log(mintPublicKey.toString())
        const metadata = await Metadata.load(connection, metadataAccount);
        if(metadata.data.tokenStandard == 2 ||   metadata.data.tokenStandard == 1  ||   metadata.data.tokenStandard == 3){
            throw new Error("token standard not accepted")
        }   
        //console.log("metadata",metadata)
        if(mintPublicKey.toString() == "536u55d9ixSuBJiCShTTzyhQ3NTKXNHtJsEgCHtZhz9L"){
          //console.log(metadata,"metadataaa")
        }
        if (regex.test(metadata.data.data.uri)) {
          //console.log('The string starts with the specified substring.');
          const finalData: FinalData = {};
          finalData!.fetched = {pubkeyAdded:mintAddress,image:undefined}
          finalData!.metadata = metadata
          return finalData;
          
        }
        const response = await fetch(metadata.data.data.uri);

        const data = await response.json();

        data.pubkeyAdded = mintAddress;
        const finalData: FinalData = {};
        finalData!.fetched = data;
        finalData!.metadata = metadata
        //console.log(finalData,"finaldata")
        return finalData;


    } catch (error) {
      console.error('Error fetching metadata:', error,mintAddress);

      throw error;
    }
  }

  export async function checkIfValidNFT(mintAddress:string) {
    const { metadata: { Metadata } } = programs;
    const mintPublicKey = new PublicKey(mintAddress);
    // Derive the metadata account address
    const metadataAccount = await Metadata.getPDA(mintPublicKey);
    // Fetch the metadata
    //console.log(mintPublicKey.toString())
    const metadata = await Metadata.load(connection, metadataAccount);
    console.log(metadata)
    //console.log("yo les gars")
    if(metadata.data.tokenStandard == 2 ||   metadata.data.tokenStandard == 1  ||   metadata.data.tokenStandard == 3){
      throw new Error("Sorry this NFT standard is not accepted")
     }  
    if(metadata.data.updateAuthority == undefined){
      if(metadata.data.collection == null || metadata.data.collection.key == undefined){
        throw new Error("Sorry this NFT is not accepted")

      }
      const CollLUT = await fetchColl(metadata.data.collection.key)
      if(CollLUT == undefined){
        throw new Error("Sorry this NFT is not accepted")

      }else{
        return "NFT is eligible for burning!"
      }
    }
    //console.log("yo les gars2")

    const LUT = await fetchLUTUA(metadata.data.updateAuthority)
    if (LUT == undefined){
      if(metadata.data.collection == null || metadata.data.collection.key == undefined){
        throw new Error("Sorry this NFT is not accepted")

      }
      const CollLUT = await fetchColl(metadata.data.collection.key)
      if(CollLUT == undefined){
        throw new Error("Sorry this NFT is not accepted")

      }else{
        return "NFT is eligible for burning!"
      }
    }
    if(metadata.data.tokenStandard == undefined){
      return "NFT is eligible for burning."
    }
    else{
      return "NFT is eligible for burning!"
    }
  }
